/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationOptionsBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return RecommendationOptionsBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationOptionsBase>): RecommendationOptionsBase {
        let obj = Object.assign(new RecommendationOptionsBase(), model);
        RecommendationOptionsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationOptionsBase>): RecommendationOptionsBase {
        if (!model) return null;
        return RecommendationOptionsBase.newInstance(<RecommendationOptionsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationOptionsBase) {
        if (!obj) return;

        models.RecommendationOptionsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationOptionsBase): boolean {
        switch (obj.__type)
        {
            case "RecommendationOptionsForCostSavings":
                Object.setPrototypeOf(obj, models.RecommendationOptionsForCostSavings.prototype);
                break;
            case "RecommendationOptionsForSkuDetails":
                Object.setPrototypeOf(obj, models.RecommendationOptionsForSkuDetails.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof RecommendationOptionsBase)[] {
        return [
            models.RecommendationOptionsForCostSavings,
            models.RecommendationOptionsForSkuDetails,
        ];
    }

    fixupFields() {
        if (typeof this.resolved_at === "string") {
            this.resolved_at = new Date(<string><any>this.resolved_at);
        }
        if (this.cost_saving_details) {
            models.CostSavingsBase.fixupPrototype(this.cost_saving_details);
        }
    }

    /**
     * Indicates the action for the resource recommendation
     */
    action_name: models.ResourceRecommendationSupportedAction;

    cost_saving_details: models.CostSavingsBase;

    /**
     * Time at which the recommendation has been resolved.
     */
    resolved_at: Date;

}
